/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PhaseWithContent } from '../../models/phase-with-content';
import { UpdatePhaseListDto } from '../../models/update-phase-list-dto';

export interface IlsControllerReorderPhaseList$Params {
  ilsId: string;
      body: UpdatePhaseListDto
}

export function ilsControllerReorderPhaseList(http: HttpClient, rootUrl: string, params: IlsControllerReorderPhaseList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PhaseWithContent>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerReorderPhaseList.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PhaseWithContent>>;
    })
  );
}

ilsControllerReorderPhaseList.PATH = '/ils/{ilsId}/phaseList';
